export const s = {
  page: {
    padding: "clamp(0.75rem, 3vw, 1.5rem) clamp(0.75rem, 4vw, 2rem)",
    maxWidth: 960,
    margin: "0 auto",
    width: "100%",
    minWidth: 0,
  },
  h1: {
    fontSize: 22,
    fontWeight: 700,
    marginBottom: "1.25rem",
    color: "#ffffff",
  },
  h3: {
    fontSize: 15,
    fontWeight: 600,
    marginBottom: ".75rem",
    color: "#ffffff",
  },
  formCard: {
    background: "#12122a",
    border: "1px solid #1e1e3a",
    borderRadius: 12,
    padding: "clamp(0.9rem, 2.5vw, 1.25rem) clamp(0.9rem, 3vw, 1.5rem)",
    marginBottom: "1.5rem",
    boxShadow: "0 4px 24px rgba(0,0,0,0.4)",
  },
  resultCard: {
    background: "#12122a",
    border: "1px solid #1e1e3a",
    borderRadius: 12,
    padding: "clamp(0.8rem, 2.5vw, 1rem) clamp(0.9rem, 3vw, 1.25rem)",
    marginBottom: ".75rem",
    boxShadow: "0 4px 24px rgba(0,0,0,0.4)",
  },
  grid2: {
    display: "grid",
    gridTemplateColumns: "repeat(auto-fit, minmax(220px, 1fr))",
    gap: 10,
  },
  fieldLabel: {
    fontSize: 12,
    color: "#a0a0b8",
    display: "block",
    marginBottom: 4,
    textTransform: "uppercase",
    letterSpacing: "0.08em",
  },
  input: {
    width: "100%",
    padding: "7px 10px",
    fontSize: 13,
    background: "#0a0a1a",
    border: "1px solid #1e1e3a",
    borderRadius: 6,
    boxSizing: "border-box",
    outline: "none",
    color: "#ffffff",
  },
  btnPrimary: {
    padding: "8px 18px",
    fontSize: 13,
    fontWeight: 600,
    background: "#6c63ff",
    color: "#fff",
    border: "none",
    borderRadius: 8,
    cursor: "pointer",
  },
  btnGhost: {
    padding: "8px 18px",
    fontSize: 13,
    background: "transparent",
    color: "#a0a0b8",
    border: "1px solid #1e1e3a",
    borderRadius: 8,
    cursor: "pointer",
  },
  btnSm: {
    fontSize: 12,
    padding: "4px 10px",
    background: "transparent",
    border: "1px solid #1e1e3a",
    borderRadius: 6,
    cursor: "pointer",
    marginRight: 4,
    color: "#a0a0b8",
  },
  tableWrap: { width: "100%", overflowX: "auto" },
  table: {
    width: "100%",
    minWidth: 640,
    borderCollapse: "collapse",
    fontSize: 13,
  },
  th: {
    textAlign: "left",
    padding: "8px 12px",
    background: "#0d0d1f",
    color: "#a0a0b8",
    fontSize: 12,
    fontWeight: 500,
    borderBottom: "1px solid #1e1e3a",
    textTransform: "uppercase",
    letterSpacing: "0.08em",
  },
  tr: { borderBottom: "1px solid #1e1e3a" },
  td: { padding: "9px 12px", color: "#ffffff" },
  error: { color: "#ef5350", fontSize: 13 },
  muted: { color: "#a0a0b8", fontSize: 13 },
  resultRow: {
    display: "flex",
    justifyContent: "space-between",
    alignItems: "center",
    flexWrap: "wrap",
    rowGap: 4,
    padding: "5px 0",
    borderTop: "1px solid #1e1e3a",
    fontSize: 13,
  },
};
